import * as React from "react";

interface DataHeaderProps {
  title?: string;
  subtitle?: string;
  className?: string;
}

const DataHeader: React.FC<DataHeaderProps> = ({ 
  title = "Data Management",
  subtitle,
  className = ''
}) => {
  return (
    <div className={className}>
      <h1 className="text-xl font-semibold text-slate-800 m-0 md:text-2xl">{title}</h1>
      {subtitle && <p className="text-xs text-slate-500 mt-1 md:text-sm">{subtitle}</p>}
    </div>
  );
};

export default DataHeader;
